/**
 * This file is used to configure the app
 *
 * If you have the "Cannot find name 'defineAppConfig'.ts(2304)" error
 * update the root tsconfig.json file to include the following:
 *
 *  "extends": "./base/.nuxt/tsconfig.json"
 *
 */

import { configure } from 'vee-validate'

// Only validate inputs on blur
configure({
  validateOnBlur: true,
  validateOnChange: false,
  validateOnModelUpdate: false,
  validateOnInput: false,
})

export default defineAppConfig({
  app: {
    // TODO: remove this, only used for the muted tabs menu color right now.
    isStagedoos: false,
    // Is the feature enabled to create inactive users?
    allowInactiveUsers: false,
    // Is the feature enabled to move organizations to other partners?
    enableOrganizationsMoving: false,
  },
  // Theme configuration - most of these are overwritten in useTheme.ts
  theme: {
    fonts: {
      sans: 'Inter Variable',
      heading: 'Inter Variable',
    },
    defaultShape: 'rounded', // 'rounded' | 'straight'
    defaultShapes: {
      avatar: 'full',
      button: 'rounded',
      accordion: 'rounded',
      autocompleteItem: 'rounded',
      buttonAction: 'rounded',
      buttonIcon: 'rounded',
      buttonClose: 'rounded',
      card: 'rounded',
      dropdown: 'rounded',
      iconBox: 'rounded',
      input: 'rounded',
      message: 'rounded',
      pagination: 'rounded',
      progress: 'rounded',
      prose: 'rounded',
      tabSlider: 'rounded',
      tag: 'rounded',
    },
    header: {
      // Use the full width of the screen for the header?
      fullWidth: false,
      // Which variant of the header to use?
      // 'legacy' is the old style with the menu below the header.
      variant: 'tab', // 'tab' | 'legacy',
      // Use a sticky header?
      sticky: true,
      // Show the language toggle in the header?
      // Not that it only appears when the tenant config has i18n enabled too.
      languageToggle: true,
      // Center the menu items in the header?
      centerMenuItems: false,
      menu: {
        // Font class for the menu items
        items: {
          fontClass: 'font-semibold',
        },
      },
    },
    footer: {
      variant: 'maud', // 'maud' | 'legacy'
    },
    cssVariables: {
      // TODO: default value fallback doesn't work for the volunteerly layer, not sure why.
      // Not sure if we should keep this, maybe move to a stylesheet with default values.
      'color-theme-footer-background': 'rgb(var(--color-primary-800))',
    } as Record<string, string>,
  },
  colorMode: {
    // Make sure we're setting 'light' and 'dark' instead of 'light-mode' and 'dark-mode' classes on the html element.
    classSuffix: '',
  },
})
